import { type ThemeOptions } from '@mui/material';

export function createListStyles() {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-focusVisible': {
            '&::after': {
              borderRadius: `${theme.ui.focus.borderRadius}`,
              content: '""',
              inset: 4,
              outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
              outlineOffset: `${theme.ui.focus.outlineOffset}`,
              position: 'absolute',
            },
            background: 'none',
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
